import {
	PATH_AUTOSHIP,
	PATH_DIGITAL_MEDIA,
	PATH_ORDER_HISTORY,
	PATH_PAYMENT_METHODS,
	PATH_PROFILE,
	PATH_SUBSCRIPTIONS,
	PATH_USER_ADDRESS_MANAGEMENT,
  ORG_PATHS,
  PATH_REDEEM_CODE,
  PATH_ACCOUNT_CREATION,
  PATH_ACCOUNT_CREATION_PAGE
} from "../../../constants";

export const menuLinks = {
  linkGroup: [
    {
      links: [
        {
          name: 'Order History',
          url: PATH_ORDER_HISTORY
        },
        {
          name: 'Autoship',
          url: PATH_AUTOSHIP
        },
        {
          name: 'Subscriptions',
          url: PATH_SUBSCRIPTIONS
        },
        {
          name: 'Digital Library',
          url: PATH_DIGITAL_MEDIA
        },
        {
          name: 'Redeem Code',
          url: PATH_REDEEM_CODE
        }
      ]
    },
    {
      title: 'My Settings',
      links: [
        {
          name: 'Profile',
          url: PATH_PROFILE
        },
        {
          name: 'Addresses',
          url: PATH_USER_ADDRESS_MANAGEMENT
        },
        {
          name: 'Payment Methods',
          url: PATH_PAYMENT_METHODS
        },
      ]
    },
    {
      title: 'Developer Links',
      links: [
        {
          name: 'Account Creation',
          url: PATH_ACCOUNT_CREATION
        },
        {
          name: 'Account Creation V2',
          url: PATH_ACCOUNT_CREATION_PAGE
        },
      ]
    }
  ]
};

export const orgMenuLinks = {
  linkGroup: [
    {
      links: [
        {
          name: 'Order History',
          url: ORG_PATHS.ORDER_HISTORY
        },
        {
          name: 'Autoship',
          url: ORG_PATHS.AUTOSHIP
        },
        {
          name: 'Subscriptions',
          url: ORG_PATHS.SUBSCRIPTIONS
        },
        {
          name: 'Billing',
          url: ORG_PATHS.BILLING_ACTIVITY
        }
      ]
    },
    {
      title: 'Settings',
      links: [
        {
          name: 'Organization Profile',
          url: ORG_PATHS.PROFILE
        },
        {
          name: 'Addresses',
          url: ORG_PATHS.ADDRESS_MANAGEMENT
        },
        {
          name: 'Groups (Staff)',
          url: ORG_PATHS.GROUPS
        }
      ]
    },
    {
      title: 'Developer Links',
      links: [
      ]
    }
  ]
};
